import React from 'react';

/**
 * Formats a name by making the last word italic
 * @param name - The full name string
 * @returns JSX element with first name(s) normal and last name italic
 */
export const formatNameWithItalicLast = (name: string): React.ReactElement => {
  if (!name || typeof name !== 'string') {
    return React.createElement(React.Fragment, null, '');
  }

  const nameParts = name.trim().split(' ');
  
  if (nameParts.length === 1) {
    return React.createElement('span', { 
      className: 'italic',
      style: {
        color: '#10333B',
        fontFamily: '"Playfair Display", serif',
        fontSize: '40px',
        fontStyle: 'italic',
        fontWeight: 400,
        lineHeight: '110%',
        letterSpacing: '-1.6px'
      }
    }, name);
  }

  const firstName = nameParts.slice(0, -1).join(' ');
  const lastName = nameParts[nameParts.length - 1];

  return React.createElement(React.Fragment, null,
    firstName,
    ' ',
    React.createElement('span', { 
      className: 'italic',
      style: {
        color: '#10333B',
        fontFamily: '"Playfair Display", serif',
        fontSize: '40px',
        fontStyle: 'italic',
        fontWeight: 400,
        lineHeight: '110%',
        letterSpacing: '-1.6px'
      }
    }, lastName)
  );
};

/**
 * Formats a name by making the last word italic (returns string version)
 * @param name - The full name string
 * @returns String with first name(s) normal and last name italic
 */
export const formatNameWithItalicLastString = (name: string): string => {
  if (!name || typeof name !== 'string') {
    return '';
  }

  const nameParts = name.trim().split(' ');
  
  if (nameParts.length === 1) {
    return `*${name}*`;
  }

  const firstName = nameParts.slice(0, -1).join(' ');
  const lastName = nameParts[nameParts.length - 1];

  return `${firstName} *${lastName}*`;
};
